import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { AddteamsModalComponent } from '../addteams-modal/addteams-modal.component';
import { Router } from '@angular/router';
import { SuccessAccountCreatedComponent } from '../success-account-created/success-account-created.component';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-share-code-add-teams',
  templateUrl: './share-code-add-teams.component.html',
  styleUrls: ['./share-code-add-teams.component.scss']
})
export class ShareCodeAddTeamsComponent implements OnInit {

  shareCodeText:string = 'Copy'
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogue: MatDialog,
    private router: Router,
    private toast: ToastrService,
    private commonService: CommonService
  ) { }

  ngOnInit(): void {
  }

  AddMoreTeams() {
    try {

      this.dialogue.open(AddteamsModalComponent,{
        hasBackdrop: true,
        disableClose: true,
        height: "400px",
        width:"469px",
        data: {
          userType: {
            titleOne: '',
            titleTwo: '',
            text: "",
            user: '',
            imgPath: '',
            id: '',
            access: 'add',
            teamName: ''
          }
        },
      });
    }
    catch (e) { }
  }

  copyCode(code:any) {
    try {
      navigator.clipboard.writeText(code);
      this.shareCodeText = "copied";
      this.toast.success('Team code copied successfully');
     }
    catch (e) { }
  }

  CloseModal(){
    this.commonService.callTeamList(true);
    return
    let currentURL = this.router.url
    this.router.navigateByUrl('/organization_dash', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentURL]);
    });

  }


   // **********************************************************************************
  // successCreation START

   // successCreation END
  // **********************************************************************************


}
